export const ErrorCode = {
    AUTH_REQUIRED: 'AUTH_REQUIRED',
    AUTH_INVALID: 'AUTH_INVALID',
    AUTH_EXPIRED: 'AUTH_EXPIRED',
    HOST_OFFLINE: 'HOST_OFFLINE',
    HOST_NOT_FOUND: 'HOST_NOT_FOUND',
    HOST_BUSY: 'HOST_BUSY',
    APPROVAL_REQUIRED: 'APPROVAL_REQUIRED',
    APPROVAL_TIMEOUT: 'APPROVAL_TIMEOUT',
    APPROVAL_DENIED: 'APPROVAL_DENIED',
    ACCESS_CODE_REQUIRED: 'ACCESS_CODE_REQUIRED',
    ACCESS_CODE_INVALID: 'ACCESS_CODE_INVALID',
    ACCESS_CODE_LOCKED: 'ACCESS_CODE_LOCKED',
    POLICY_DENIED: 'POLICY_DENIED',
    IP_NOT_ALLOWED: 'IP_NOT_ALLOWED',
    PROTOCOL_VERSION_MISMATCH: 'PROTOCOL_VERSION_MISMATCH',
    PROTOCOL_INVALID: 'PROTOCOL_INVALID',
    SESSION_NOT_FOUND: 'SESSION_NOT_FOUND',
    SESSION_EXPIRED: 'SESSION_EXPIRED',
    RATE_LIMITED: 'RATE_LIMITED',
    INTERNAL: 'INTERNAL',
};
const codeSet = new Set(Object.values(ErrorCode));
export function isErrorCode(value) {
    return typeof value === 'string' && codeSet.has(value);
}
//# sourceMappingURL=error-codes.js.map